import React from 'react';
import { TransitionGroup, CSSTransition as ReactTransition } from 'react-transition-group';

const Transition = props => {
	const { children, location } = props;
	const timeout = 300;

	const getTransitionStyles = {
		entering: {
			opacity: 0,
		},
		entered: {
			transition: `opacity ${timeout}ms ease-in-out`,
			opacity: 1,
		},
		exiting: {
			transition: `opacity ${timeout}ms ease-in-out`,
			opacity: 0,
		},
	};

	const mainContentStyle = {}

	return (
		<TransitionGroup>
			<ReactTransition
				key={location.pathname}
				timeout={{ enter: timeout, exit: timeout }}
				onExit={(node) => {
					node.style.width = '100vw'; // Ensure full width
					node.style.height = '100vh'; // Ensure full height
				}}
				onEntered={(node) => {
					node.style.width = '';
					node.style.height = '';
					window.scrollTo(0, 0); // Restore scroll on new page
				}}
			>
				{(status) => (
					<div style={{ ...getTransitionStyles[status], ...mainContentStyle }} aria-live="assertive">
						{children}
					</div>
				)}
			</ReactTransition>
		</TransitionGroup >
	);
};

export default Transition;
